export default class PackagingTypeManagementColumnModel {
  static PackagingTypeManagementColumn = [
    {
      title: 'Packaging Category',
      field: 'packagingCategory'
    },
    {
      title: 'Carton Qty',
      type: 'numeric',
      field: 'quantity'
    },
    {
      title: 'Qty per Sleeve',
      type: 'numeric',
      field: 'sleevePkt',
      headerStyle: { textAlign: 'right' },
      cellStyle: { textAlign: 'right' }
    },
    {
      title: 'Sleeve Qty',
      type: 'numeric',
      field: 'sleeveQty',
      editable: 'never'  // 不可编辑，自动计算
    },
    {
      title: 'Packaging Type',
      field: 'packagingTypeName',
      editable: 'never'  // 不可编辑，自动生成
    }
  ]
}
